export const makeExistingPayment = (index: number) => {
  return 'EXISTING_PAYMENT_' + index;
};
export const FIRST_EXISTING_PAYMENT = 'EXISTING_PAYMENT_0';
export const NEW_PAYMENT = 'NEW_PAYMENT';
